import React from 'react';
import './TabNavigation.css';
import { useLanguage } from '../../contexts/LanguageContext';

/**
 * Shared TabNavigation Component
 * Replaces duplicated tab strips on LandingPage and MarketplaceDetailPage.
 *
 * @param {Array}  tabs       - [{ key, label, onClick }]
 * @param {String} activeKey  - key of the currently active tab
 * @param {String} ariaLabel  - landmark label for the nav (optional)
 */
const TabNavigation = ({ tabs, activeKey, ariaLabel }) => {
  const { t } = useLanguage();
  return (
    <nav
      className="shared-tab-navigation"
      aria-label={ariaLabel || t('tabs.navigation') || 'Tabnavigation'}
    >
      {tabs.map((tab) => {
        const isActive = tab.key === activeKey;
        return (
          <button
            key={tab.key}
            type="button"
            className={`shared-tab-button${isActive ? ' active' : ''}`}
            onClick={tab.onClick}
            aria-current={isActive ? 'page' : undefined}
          >
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
};

export default TabNavigation;
